document.querySelectorAll('.click-share').forEach(function(element) {
    element.addEventListener('click', function(event) {
        event.preventDefault();

        const link = this.getAttribute('data-link');

        const messageSpan = this.closest('.recipe-modal')?.querySelector('.copied-message');

        navigator.clipboard.writeText(link).then(() => {
            if (messageSpan) {
                messageSpan.classList.remove('hidden');
                setTimeout(() => {
                    messageSpan.classList.add('hidden');
                }, 1000);
            }
        }).catch(err => {
            console.error('Erro ao copiar o link: ', err);
            alert('Não foi possível copiar o link.');
        });
    });
});